
declare var Object: any;
export interface AdcTripSignatureStatsInterface {
  "id"?: string;
  "vdate"?: any;
  "serviceType"?: string;
  "tenantId": number;
  "consumerId"?: number;
  "count": number;
}

export class AdcTripSignatureStats implements AdcTripSignatureStatsInterface {
  "id": string;
  "vdate": any;
  "serviceType": string;
  "tenantId": number;
  "consumerId": number;
  "count": number;
  constructor(data?: AdcTripSignatureStatsInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `AdcTripSignatureStats`.
   */
  public static getModelName() {
    return "AdcTripSignatureStats";
  }

  /**
  * This method creates an instance of AdcTripSignatureStats for dynamic purposes.
  **/
  public static factory(data: AdcTripSignatureStatsInterface): AdcTripSignatureStats{
    return new AdcTripSignatureStats(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AdcTripSignatureStats',
      plural: 'AdcTripSignatureStats',
      path: 'AdcTripSignatureStats',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "vdate": {
          name: 'vdate',
          type: 'any'
        },
        "serviceType": {
          name: 'serviceType',
          type: 'string'
        },
        "tenantId": {
          name: 'tenantId',
          type: 'number'
        },
        "consumerId": {
          name: 'consumerId',
          type: 'number'
        },
        "count": {
          name: 'count',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
